import { FC, createElement } from "react";
import { default as Stethoscope } from "components/icons/Stethoscope";
import { default as Contract } from "components/icons/Contract";
import { default as Location } from "components/icons/Location";
import { default as Taxonomy } from "components/icons/Taxonomy";
import { default as User } from "components/icons/User";
import { default as Organization } from "components/icons/Organization";
import { default as Hospital } from "components/icons/Hospital";
import { default as Success } from "components/icons/Success";
import { default as Warning } from "components/icons/Warning";
import { default as Error } from "components/icons/Error";
import { default as Info } from "components/icons/Info";

const icons: { [name: string]: FC<{ color: string }> } = {
  Stethoscope,
  Contract,
  Location,
  Taxonomy,
  User,
  Organization,
  Hospital,
  Success,
  Warning,
  Error,
  Info
};

export const getIcon = (name: string): React.FC<{ color: string }> | null => {
  const component = icons[name];
  if (component) {
    return (props) => createElement(component, { ...props });
  }
  return null;
};
